export default "__VITE_ASSET__O$sAfE4$__"